<template>
  <PageWithLayout>
    <div class="section_result">
      <div class="section_body">
        <span class="icon_result_primary"><span class="ico_brand ico_check_complete"></span></span>
        <h2 class="tit_section">
          서비스 신청이 완료 되었습니다
        </h2>
        <p class="desc_section">
          서비스 가입 승인 완료후 서비스 이용 가능한 URL을 카카오톡 알림으로 발송해드립니다.
        </p>
      </div>
      <div class="section_foot">
        <button class="btn_white" @click="goHome">서비스 신청 완료</button>
      </div>
    </div>
  </PageWithLayout>
</template>

<script>
  import routerPath from "../../../router/routerPath";

  export default {
    name: "RegistorSuccess",
    methods: {
      goHome() {
        this.$router.push(routerPath.INTRODUCE)
      }
    }
  }
</script>

<style scoped>

</style>
